var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9437 1.5H4.05634C2.64451 1.5 1.5 2.64451 1.5 4.05634V67.9437C1.5 69.3555 2.64451 70.5 4.05634 70.5H67.9437C69.3555 70.5 70.5 69.3555 70.5 67.9437V4.05634C70.5 2.64451 69.3555 1.5 67.9437 1.5ZM4.05634 0H67.9437C70.1839 0 72 1.81608 72 4.05634V67.9437C72 70.1839 70.1839 72 67.9437 72H4.05634C1.81608 72 0 70.1839 0 67.9437V4.05634C0 1.81608 1.81608 0 4.05634 0Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6951 16C40.3677 16 40.9215 16.5089 40.9923 17.1628L41 17.3049V22.4406C41 23.1613 40.4158 23.7455 39.6951 23.7455C39.0224 23.7455 38.4686 23.2366 38.3978 22.5828L38.3901 22.4406L38.3891 18.6099H27.305V43.3902H31.1357C31.8564 43.3902 32.4406 43.9744 32.4406 44.6951C32.4406 45.3678 31.9317 45.9215 31.2779 45.9924L31.1357 46H20.8644C20.1437 46 19.5594 45.4158 19.5594 44.6951C19.5594 44.0224 20.0684 43.4687 20.7222 43.3978L20.8644 43.3902H24.6951V18.6099H13.6099V22.4406C13.6099 23.1132 13.1009 23.667 12.4471 23.7379L12.3049 23.7455C11.6323 23.7455 11.0785 23.2366 11.0077 22.5828L11 22.4406V17.3049C11 16.6323 11.5089 16.0785 12.1628 16.0077L12.3049 16H26H39.6951Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 56H10.5C10.2239 56 10 56.3358 10 56.75C10 57.1642 10.2239 57.5 10.5 57.5H61.5C61.7761 57.5 62 57.1642 62 56.75C62 56.3358 61.7761 56 61.5 56Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.8595f4f7a99d423f99096f1e10ddf2db.svg";
export { ForwardRef as ReactComponent };